import React, { useEffect, useState } from 'react';
import avatar from '../../assets/Images/postimg.jpg';
import '../../module/designer/Designer.css';
import moment from 'moment/moment';
import { Link } from 'react-router-dom';
import Colors from '../../Constant/Colors';
import ThumbUpOffAltOutlinedIcon from '@mui/icons-material/Favorite';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import ShareOutlinedIcon from '@mui/icons-material/ShareOutlined';
import { Button, Divider } from '@mui/material';
import client from '../../API/client';

export const Userfeed = ({ props }) => {
  const [likes, setLikes] = useState([]);
  const [isLiked, setisLiked] = useState(false);
  const current_user_id = JSON.parse(localStorage.getItem('user_id'));
  const Role = JSON.parse(localStorage.getItem('Role'));
  useEffect(() => {
    getLikes();
  }, []);
  const getLikes = async () => {
    try {
      await client.get(`/user/post/like/${props.post_id}`).then((res) => {
        console.log(res.data) 
        setLikes(res.data);
        if (res.data.includes(current_user_id)) {
          setisLiked(true);
        } else {
          setisLiked(false);
        }
      });
    } catch (error) {
      console.log(error);
    }
  };
  const handleLikeUnlike = async (prop) => {
    console.log(prop);
    if (prop) {
      try {
        await client.delete(`/user/post/unlike/${current_user_id}/${props.post_id}`).then((res) => {
          console.log(res.data);
          getLikes();
        });
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        await client.post(`/user/post/like/${current_user_id}/${props.post_id}`).then((res) => {
          console.log(res.data);
          getLikes();
        });
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <>
      <div key={props.post_id} style={{ margin: '20px' }}>
        <div
          style={{
            boxShadow: '0px 0px 25px -10px rgba(0, 0, 0, 0.38)',
            padding: '20px 20px 0px 20px',
            borderRadius: 0,
            backgroundColor: 'white',
          }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              position: 'relative',
              backgroundColor: 'white',
            }}>
            <div
              style={{
                display: 'flex',
                gap: '20px',
                backgroundColor: 'white',
              }}>
              <img
                alt="Avatar"
                src={avatar}
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  objectFit: 'cover',
                  backgroundSize: 'cover',
                }}
              />
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontSize: '16px', fontWeight: '500' }}>
                  {Role === 'designer' ? (
                    <Link
                      style={{
                        textDecoration: 'none',
                        color: Colors.primary,
                      }}
                      to={`/search/user/user-profile/${props.user_role}/${props.user_name}/${props.user_email}/${props.user_id}`}>
                      {props.user_name}
                    </Link>
                  ) : (
                    <Link
                      style={{
                        textDecoration: 'none',
                        color: Colors.primary,
                      }}
                      to={`/user/user-profile/${props.user_role}/${props.user_name}/${props.user_email}/${props.user_id}`}>
                      {props.user_name}
                    </Link>
                  )}
                </span>
                <span style={{ fontSize: '12px', color: 'grey' }}>{moment(props.createdat).fromNow()}</span>
              </div>
            </div>
            <div></div>
          </div>
          <div className="contents" style={{ backgroundColor: 'white' }}>
            <p>{props.desc}</p>

            {props.img && (
              <img
                style={{
                  width: '100%',
                  maxHeight: '500px',
                  objectFit: 'cover',
                  marginTop: '10px',
                }}
                src={props.img}
              />
            )}
            <Divider variant="fullWidth" sx={{ color: 'purple', borderWidth: 1 }} />

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <div>
                
               <ThumbUpOffAltOutlinedIcon sx={{ marginLeft: '70px', marginTop: '15px',color:`${isLiked ? "red" : 'grey'}`,'&:hover': {color:`${isLiked ? "lightpink" : 'lightgrey'}`}, }} onClick={()=>handleLikeUnlike(isLiked)} />
                <p style={{ marginLeft: '70px' }}>
                {likes.length} {isLiked ? 'likes' : 'likes'}
                  
                </p>
              </div>
              <div>
                <CommentOutlinedIcon sx={{ marginTop: '15px' }} />
                <p style={{ marginLeft: '-17px' }}>comment</p>
              </div>
              <div>
                <ShareOutlinedIcon sx={{ marginRight: '40px', marginTop: '15px' }} />
                <p style={{ marginLeft: '-4px' }}>share</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
